<script setup lang="ts">
import AcceptationRateCard from '~/components/influencer/profile/about/activity/AcceptationRateCard.vue'
import AnswerRateCard from '~/components/influencer/profile/about/activity/AnswerRateCard.vue'
import Candidates from '~/components/influencer/profile/about/activity/Candidates.vue'
import DaysLeft from '~/components/influencer/profile/about/activity/DaysLeft.vue'
import FeedbackCard from '~/components/influencer/profile/about/activity/FeedbackCard.vue'
import OrangeTitleWithSpacedContent from '~/components/ui/Sections/OrangeTitleWithSpacedContent.vue'

import { useCuratorContestsInfos } from '~/composables/useCuratorContestsInfos'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'

type Props = {
  influencer: Influencer | StatsV3Influencer
}

const props = defineProps<Props>()

const { curatorIsContest, daysLeft } = useCuratorContestsInfos(props.influencer)
const isContest = computed(() => curatorIsContest(props.influencer))

const feedbackCount = computed<number>(
  () => props.influencer.latest_stats?.feedback_count ?? 0,
)

const answerRate = computed<number>(
  () => props.influencer.latest_stats?.answer_rate_monthly ?? 0,
)

const acceptationRate = computed<number | null>(() => {
  const value = props.influencer?.latest_stats?.acceptation_rate

  if (value !== null || undefined) return value ?? 0
  else return null
})
</script>

<template>
  <OrangeTitleWithSpacedContent>
    <template #title>{{
      $t('influencer.profile.slug.about.infosAndActivity01')
    }}</template>
    <template #content>
      <FeedbackCard v-if="!isContest" :value="feedbackCount" />
      <AnswerRateCard v-if="!isContest" :value="answerRate" />
      <AcceptationRateCard
        v-if="!isContest && acceptationRate !== null"
        :value="acceptationRate"
      />
      <DaysLeft v-if="isContest && daysLeft !== undefined" :value="daysLeft" />
      <Candidates
        v-if="isContest && influencer.contest"
        :value="influencer.contest.contestants"
      />
    </template>
  </OrangeTitleWithSpacedContent>
</template>
